import { checkPerms } from './utils';

// The latest MCR opens in E-Cabinet, whose route requires file_cabinet_enabled.
export const canOpenMcr = mcrId => !!mcrId && checkPerms('file_cabinet_enabled');
export const openMcr = mcrId => window.open(`/e-cabinet/id/${mcrId}`, '_blank');
